/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M1.735.298L10 8.562 18.265.298a1.016 1.016 0 011.437 1.437L11.437 10l8.265 8.266a1.016 1.016 0 01-1.437 1.437l-8.266-8.265-8.264 8.265a1.016 1.016 0 01-1.437-1.437l8.264-8.266L.298 1.735A1.016 1.016 0 011.735.298z" _fill="#000" fill-rule="evenodd"/>'
  }
})
